import React from 'react'
import './Shadow.scss'

const Shadow = () => {
  return (
    <div className='shadow'>
    </div>
  )
}

export default Shadow